<template>
    <div class="message_action_container">
        <div class="title_message" :class="[hideAction ? 'hide_action' : '']">
            <slot name="above-message"></slot>
            <p>{{message}}</p>
        </div>
        <ns-button v-if="!hideAction" class="message_action" :fluid="($mq !== 'desktop' && $mq !== 'desktopHD')" theme="secondary-outline" @click="_messageAction">{{actionName}}</ns-button>
        <ns-button v-if="!hideSecondaryAction" class="secondary_message_action" :fluid="($mq !== 'desktop' && $mq !== 'desktopHD')" theme="secondary" @click="_secondaryMessageAction">{{secondaryActionName}}</ns-button>
        <div class="below-action">
            <slot name="below-action"></slot>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueMq from 'vue-mq';
    import {events, util} from '@nuskin/ns-util';
    import {UserService} from '@nuskin/ns-account';

    Vue.use(VueMq, {
		breakpoints: {
			mobile: 375,
			phablet: 768,
			tablet: 1024,
			desktop: 1440,
			desktopHD: Infinity
		}
	});

    const nsMessageAction = {
        name: "nsMessageAction",
        props: {
            /**
             * Message to be displayed
             */
            message: String,
            /**
             * URL to link too when action button clicked
             */
            actionurl: String,
            /**
             * URL for secondary action
             */
            secondaryactionurl: String,
            /**
             * Text to display on button
             */
            actionName: String,
            /**
             * Text to display on secondary action
             */
            secondaryActionName: String,
            /**
             * use login to perform login instead of url redirect
             */
            actionType: {
                type: String,
                default: ""
            },
            /**
             * Flag to use an event to perform secondary action
             */
            useEventForSecondaryAction: Boolean
        },
        data: function() {
            return {
                /**
                 * Used to go to a specific URL if override specified
                 */
                secondaryActionPDPSKU: ""
            }
        },
        computed: {
            hideAction: function() {
                if (this.actionType === "login" && UserService.isLoggedIn()) {
                    return true;
                }

                return false;
            },
            hideSecondaryAction: function() {
                return !this.secondaryActionName && !this.secondaryactionurl;
            }
        },
        methods: {
            /**
             * Used to either login or redirect on action click
             * @private
             */
            _messageAction: function() {
                if (this.actionType === "login") {
                    events.publish(events.authentication.REQUEST_FOR_LOGIN);
                } else {
                    window.location = actionurl;
                }
            },
            _secondaryMessageAction: function() {
                if (this.useEventForSecondaryAction || !this.secondaryactionurl) {
                    window.location = util.getLocaleUrl() + "products/product." + this.secondaryActionPDPSKU + ".html";
                } else {
                    window.location = this.secondaryactionurl;
                }
            }
        },
        mounted: function() {
            events.subscribe(events.shop.SHOW_EXCLUSIVE_OFFER_DETAILS, item => {
                if (item && item.sku) {
                    this.secondaryActionPDPSKU = item.sku;
                }
            });
        }
    }

    export default nsMessageAction;
</script>

<style lang="scss" scoped>
    @use "sass:map";
    @use '~@nuskin/ns-core-styles/src/scss/global.mixins';
    @use '~@nuskin/ns-core-styles/src/scss/globalVariables';
    @use '~@nuskin/ns-core-styles/src/scss/colors';

    .message_action_container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
        height: auto;
        background-color: rgba(147,0,147,0.06);
        padding: 14px 16px;
        padding-top: 20px;

        p {
            margin-top: 13px;
            color:  map.get(colors.$themeColors, color-primary-text);
            @include global.p-medium();
        }

        .message_action {
            margin-top: 7px;
        }

        .secondary_message_action {
            margin-top: 17px;
        }

        .hide_action {
            flex-direction: row !important;
            justify-content: space-between;
            width: 100%;
        }
    }

    @media (min-width: 1024px) {
        .message_action_container {
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-start;
            padding: 10px 17px;
            padding-top: 15px;

            p {
                max-width: 313px;
            }

            .title_message {
                display: flex;
                flex-direction: column;
            }

            .hide_action {
                p {
                    margin-top: 0;
                }
            }

            ns-button {
                position: absolute;
                right: 15px;
            }
        }

    }
</style>